import { createContext } from "react";

export interface FAQContextType {
  scrollToFAQ: () => void;
  openFaq: (index: number) => void;
  faqToOpen: number | null;
  setFaqRef: (el: HTMLDivElement | null) => void;
}

export const FAQContext = createContext<FAQContextType>({
  scrollToFAQ: () => {},
  openFaq: () => {},
  faqToOpen: null,
  setFaqRef: () => {},
});
